import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { tinykeys, KeyBindingMap } from 'tinykeys';

// models
import { DEFAULT_PANEL_WIDTH_PX, IPanelTitleOptions } from '../../services/side-panel.service';
import { IConfirmModalAnswer } from '../../modals/confirm-modal/models/confirmModalAnswer';
import { IConfirmModalData } from '../../modals/confirm-modal/models/confirmModalData';

// components
import { ConfirmModalComponent } from '../../modals/confirm-modal/confirm-modal.component';

// service
import { SidePanelService } from '../../services/side-panel.service';

import { SHARED_MODULES } from '../../../shared.';
import { PhButtonComponent } from '../ph-button/ph-button.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';

@Component({
    selector: 'app-side-panel',
    templateUrl: 'side-panel.component.html',
    styleUrls: ['side-panel.component.scss'],
	imports: [SHARED_MODULES, PhButtonComponent, PhIconWrapperComponent],
    standalone: true
})
export class SidePanelComponent implements OnInit, OnDestroy {
	tinykeys: any;

	@Input() side: 'left' | 'right' = 'right';
	@Input() enterSubmit: boolean = true;
	@Input() opened: boolean = false;
	@Input() closeIcon: string = 'close';
	@Input() zIndex: number = 2000;

	@Output('closePanel') closeEmitter: EventEmitter<void> = new EventEmitter<void>();

	@ViewChild(MatDrawer) drawer: MatDrawer;

	constructor(
		private dialog: MatDialog,
		public service: SidePanelService
	) {}

	get checkedOptionValue(): any {
		return this.service.titleOptions?.find((option: IPanelTitleOptions) => option.checked)?.value;
	}

	ngOnInit(): void {
		const keyBinding: KeyBindingMap = {
			'Escape': () => {
				if (this.drawer.opened) this.closePanel();
			}
		}
		if (this.enterSubmit) {
			keyBinding['Enter'] = () => {
				if (this.drawer.opened) this.applyPanel();
			}
		}
		this.tinykeys = tinykeys(window, keyBinding);
	}

	applyPanel(): void {
		if (this.service.disabledApply) return;
		this.service.applySubject.next();
	}

	cancelPanel(): void {
		this.service.cancelSubject.next();
		if (this.service.cancelClose) this.close();
	}

	cancelProps(): void {
		this.service.showButtons = true;
		this.service.cancelClose = true;
		this.service.mustSaveModal = false;
		this.service.panelWidth = DEFAULT_PANEL_WIDTH_PX;
		this.service.titleOptions = null;
		this.service.hasBackdrop = false;
	}

	closePanel(): void {
		if (this.service.mustSaveModal && !this.service.disabledApply) {
			const dialogRef = this.dialog.open<ConfirmModalComponent, IConfirmModalData, IConfirmModalAnswer>(ConfirmModalComponent, {
				width: '574px',
				autoFocus: false,
				backdropClass: 'back-drop',
				data: {
					label: 'MUST_SAVE_CHANGES',
					cancelLabel: 'NO',
					confirmLabel: 'YES',
					twoAnswers: true
				}
			});

			dialogRef.afterClosed().subscribe((result: IConfirmModalAnswer) => {
				if (result.answer) this.close();
			});
		} else {
			this.close();
		}
	}

	close(): void {
		this.cancelProps();
		this.service.closeSubject.next();
		this.drawer.close().then();
		this.closeEmitter.emit();
	}

	ngOnDestroy(): void {
		if (this.tinykeys) this.tinykeys();
	}
}
